import { i18nLike } from "#web/services/i18nLike";
import { EmptySearchResult } from "@shopify/polaris";

import { en } from "./translations";

export const NoLeakedCodesEmptyState = () => {
  const t = i18nLike(en);

  return <EmptySearchResult description={t("noResult.description")} title={t("noResult.title")} withIllustration />;
};
